
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取部门列表
export function getSysDeptList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/tree',
    method: 'GET',
    params: parameter
  })
}

// 新增部门
export function createSysDept (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/add',
    method: 'POST',
    data: parameter
  })
}

// 编辑部门
export function editSysDept (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/modify',
    method: 'PUT',
    data: parameter
  })
}

// 删除部门
export function deleteSysDept (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/remove',
    method: 'DELETE',
    params: parameter
  })
}

// 删除部门
export function deleteUser (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user',
    method: 'DELETE',
    params: parameter
  })
}

// 获取待审核的部门列表
export function getSysDeptReviewList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/reviewList',
    method: 'GET',
    params: parameter
  })
}

// 审核部门
export function auditSysDept (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/review',
    method: 'PUT',
    data: parameter
  })
}

// 部门拖拽
export function dragSysDept (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/drag',
    method: 'PUT',
    data: parameter
  })
}

// 民族列表
export function getNationInfo () {
  return axios({
    url: sysInfo.apiRemote + '/nation',
    method: 'GET'
  })
}

// 获取所有人员列表数据
export function getUserBaseInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user',
    method: 'GET',
    params: parameter
  })
}

// 新增人员
export function insertUserBaseInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user',
    method: 'POST',
    data: parameter
  })
}

// 编辑人员
export function updateUserBaseInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user',
    method: 'PUT',
    data: parameter
  })
}

// 处理人员状态  冻结：4 解冻：1 离职：9
export function updateUserStatus (userId, status, parameter) {
  return axios({
    url: sysInfo.apiRemote + `/user/${userId}/status/${status}`,
    method: 'PUT',
    data: parameter
  })
}

// 人员转正
export function changeJobStatus (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user/formal',
    method: 'PUT',
    data: parameter
  })
}

// 基础信息导出
export function exportBaseInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user/export',
    method: 'GET',
    responseType: 'blob',
    timeout: 5 * 60 * 1000,
    params: parameter
  })
}

// 根据角色code获取全部用户
export function getUserListByCode (query) {
  return axios({
    url: sysInfo.apiRemote + '/role/user/all',
    params: query,
    method: 'GET'
  })
}

// 获取人员分组数据
export function getRoleGroupInfo (query) {
  return axios({
    url: sysInfo.apiRemote + '/group',
    params: query,
    method: 'GET'
  })
}

// 获取所有项目数据
export function getBaseProjectInfo (query) {
  return axios({
    url: sysInfo.apiRemote + '/project',
    params: query,
    method: 'GET'
  })
}

// 获取角色全部数据
export function getAllRoleList () {
  return axios({
    url: sysInfo.apiRemote + '/role/all',
    method: 'GET'
  })
}

// 人员安全信息获取
export function getPersonalSafeInfo (userId) {
  return axios({
    url: sysInfo.apiRemote + `/user/safety/${userId}`,
    method: 'GET'
  })
}

// 编辑人员安全信息
export function updatePersonalSafeInfo (query) {
  return axios({
    url: sysInfo.apiRemote + `/user/safety`,
    data: query,
    method: 'PUT'
  })
}

// 人员三级安全教育卡附件获取
export function getSafetyImgUrl (filePath) {
  return axios({
    url: sysInfo.apiRemote + `/user/file/safety/${filePath}`,
    responseType: 'blob',
    method: 'GET'
  })
}

// 获取转岗卡
export function getTransferImgUrl (filePath) {
  return axios({
    url: sysInfo.apiRemote + `/user/file/transfer/${filePath}`,
    responseType: 'blob',
    method: 'GET'
  })
}

// 获取个人信息数据
export function getPersonalInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/user/info`,
    params: parameter,
    method: 'GET'
  })
}

// 编辑个人信息数据
export function updatePersonalInfo (query) {
  return axios({
    url: sysInfo.apiRemote + `/person/info`,
    method: 'PUT',
    data: query
  })
}

// 修改密码
export function updatePassWord (query) {
  return axios({
    url: sysInfo.apiRemote + `/user/info/reset`,
    method: 'PUT',
    data: query
  })
}

// 获取地区数据
export function getAreaList () {
  return axios({
    url: sysInfo.apiRemote + `/area`,
    method: 'GET'
  })
}

// 图片预览接口
export function previewImg (filePath) {
  return axios({
    url: sysInfo.apiRemote + `/upload/preview/tmp/${filePath}`,
    responseType: 'blob',
    method: 'GET'
  })
}

// 获取选中部门列表
export function getSelectDeptList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/select',
    method: 'GET',
    params: parameter
  })
}

// 获取部门信息
export function getDeptInfo (id) {
  return axios({
    url: sysInfo.apiRemote + `/sysDept/${id}`,
    method: 'GET'
  })
}
